import styled from "styled-components/macro";

export const ContentFactory = (({ theme }) => ({
    display: "flex",
    flexDirection: "column",
  
    [theme.breakpoint.xl()]: {
      padding: "50px 50px",
    },
  
    "@media (min-width: 1480px)": {
      padding: "50px calc((100% - 1260px)/2)",
    },
}));

export const ContainerFactory = styled.div(({ theme }) => ({
    [theme.breakpoint.xl()]: {
      display: "flex",
      justifyContent: "space-between",
    },
}));

export const DesktopOnlyFactory = styled.div(({ theme }) => ({
    display: "none",
  
    [theme.breakpoint.xl()]: {
      display: "block",
    },
}));

  
export const MobileOnlyFactory = styled.div(({ theme }) => ({
    display: "block",
    [theme.breakpoint.xl()]: {
      display: "none",
    },
}));

export const ParagraphFactory = (() => ({
  fontSize: "14px",
  lineHeight: "150%",
  fontWeight: "500",
}));


export const ContainerContentFactory = styled.div(({ theme }) => ({
    margin: "auto 0",
}));

export const ContainerImageFactory = styled.img(({ theme }) => ({
    width: "100%",
    height: "auto",
    zIndex: "1",
  
    [theme.breakpoint.lg()]: {
      width: "auto",
      height: "100%",
      objectFit: "scale-down",
    },
}));

export const CardContainerFactory = (() => ({
    marginLeft: "16px",     
    paddingLeft: "16px",
    borderLeft: "1px solid",
}));

export const CardTitleFactory = (({ theme }) => ({
    fontSize: "24px",
    lineHeight: "150%",
  
    [theme.breakpoint.lg()]: {
      fontSize: "28px",
    },
}));

export const DescriptionFactory = (({ theme }) => ({
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "150%",
  
    [theme.breakpoint.lg()]: {
      fontSize: "16px",
    },
}));

export const SliderCardFactory = (({ theme }) => ({
    margin: "0 0 40px",
    maxWidth: "276px",
    height: "278px",
    paddingTop: "0",
    borderRadius: "4px",
    width: "100%",
    
    [theme.breakpoint.lg()]: {
        margin: "0 40px 40px",
        maxWidth: "249px",
    },
    
    [theme.breakpoint.xl()]: {
        margin: "0 40px",
        height: "300px",
    },
}));

export const TitleFactory = (({ theme }) => ({
    fontSize: "32px",
    fontWeight: "700",
    lineHeight: "150%",

    [theme.breakpoint.xl()]: {
        fontSize: "40px",
    },
}));

export const CardIconFactory = (()=> ({
    zIndex: "1",
    margin: "auto 0",
    objectFit: "scale-down",
}));

export const CardInfoFactory = (({ theme, active }) => ({
    display: "flex",
    justifyContent: "center",
   
    opacity: active ? "1" : "0.3",
    cursor: "pointer",
  
    [theme.breakpoint.lg()]: {
      height: "auto",
      width: "fit-content",
      justifyContent: "start",
    },
}))